// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioTab-module__dsAccented--lThZ9,.AudioTab-module__dsAccented--lThZ9 *{font-weight:500}.AudioTab-module__dsDefaultWeight--NzRCf,.AudioTab-module__dsDefaultWeight--NzRCf *{font-weight:400}h5.AudioTab-module__dsAccented--lThZ9,h5.AudioTab-module__dsAccented--lThZ9 *{font-weight:700}.AudioTab-module__dsUnderline--Pjlh1,.AudioTab-module__dsUnderline--Pjlh1 *{text-decoration:underline}.AudioTab-module__dsAccented2--nWSk5,.AudioTab-module__dsAccented2--nWSk5 *{font-weight:700}.AudioTab-module__dsBodyXL--J1GSg,.AudioTab-module__dsBodyXL--J1GSg *{font-size:18px;line-height:27px}.AudioTab-module__dsBodyLarge--HchH1,.AudioTab-module__dsBodyLarge--HchH1 *{font-size:16px;line-height:24px}.AudioTab-module__dsBody--GQv1w,.AudioTab-module__dsBody--GQv1w *{font-size:14px;line-height:20px}.AudioTab-module__dsBodySmall--o66Gl,.AudioTab-module__dsBodySmall--o66Gl *{font-size:12px;line-height:18px}.AudioTab-module__dsBodyXS--iMiNt,.AudioTab-module__dsBodyXS--iMiNt *{font-size:10px;line-height:15px}.AudioTab-module__dsActionLarge--aMAma,.AudioTab-module__dsActionLarge--aMAma *{font-size:16px;line-height:18px}.AudioTab-module__dsAction--Y1jfV,.AudioTab-module__dsAction--Y1jfV *{font-size:14px;line-height:16px}.AudioTab-module__dsActionSmall--JgpNl,.AudioTab-module__dsActionSmall--JgpNl *{font-size:12px;line-height:14px}.AudioTab-module__dsColumnHeadLine--F3i1C,.AudioTab-module__dsColumnHeadLine--F3i1C *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.AudioTab-module__dsLightXL--MEbdG,.AudioTab-module__dsLightXL--MEbdG *{font-size:120px;line-height:160px;font-weight:300}.AudioTab-module__dsLightLarge--cCkYE,.AudioTab-module__dsLightLarge--cCkYE *{font-size:48px;line-height:64px;font-weight:300}.AudioTab-module__dsLight--Uw7Jl,.AudioTab-module__dsLight--Uw7Jl *{font-size:32px;line-height:64px;font-weight:300}.AudioTab-module__dsLightSmall--F0QCi,.AudioTab-module__dsLightSmall--F0QCi *{font-size:24px;line-height:36px;font-weight:300}.AudioTab-module__dsLightXS--vh27B,.AudioTab-module__dsLightXS--vh27B *{font-size:18px;line-height:27px;font-weight:300}.AudioTab-module__container--piDZ2{display:flex;flex-direction:column;height:100%;overflow:hidden;width:100%}.AudioTab-module__container--piDZ2 .ds-react-grid{border:1px solid var(--gray);border-radius:5px;overflow:hidden}.AudioTab-module__container--piDZ2 .ds-react-grid tr td{font-size:14px}.AudioTab-module__container--piDZ2 .ds-react-grid.virtualized{height:var(--table-maxheight)}.AudioTab-module__container--piDZ2 .ds-react-grid tr:hover .TableStubCell-cell{background:#fff}.AudioTab-module__container--piDZ2 .ds-react-grid tr:hover,.AudioTab-module__container--piDZ2 .ds-react-grid tr:hover td.TableFixedCell-fixedCell,.AudioTab-module__container--piDZ2 .ds-react-grid tr:hover td.TableStubCell-cell{background-color:#f7f8fa}.AudioTab-module__container--piDZ2.AudioTab-module__compare--sVbqv .MuiGrid-item:first-child .AudioTab-module__tableWrapper--xNRqC{margin-right:5px}.AudioTab-module__container--piDZ2.AudioTab-module__compare--sVbqv .MuiGrid-item:first-child .AudioTab-module__tableWrapper--xNRqC .ds-table-fixed-column.rowActionMenu{right:-1px !important}.AudioTab-module__container--piDZ2.AudioTab-module__compare--sVbqv .MuiGrid-item:last-child .AudioTab-module__tableWrapper--xNRqC{margin-left:5px}.AudioTab-module__container--piDZ2.AudioTab-module__compare--sVbqv .AudioTab-module__tableWrapper--xNRqC .ds-react-grid{height:630px}.AudioTab-module__container--piDZ2 .MuiCollapse-wrapper .AudioTab-module__tableWrapper--xNRqC{margin:0 8px}.AudioTab-module__container--piDZ2 .MuiCollapse-wrapper .AudioTab-module__tableWrapper--xNRqC .ds-react-grid{height:auto}.AudioTab-module__container--piDZ2 .MuiCollapse-wrapper .AudioTab-module__tableWrapper--xNRqC .ds-react-grid.AudioTab-module__virtualized--YKnGu{height:auto}.AudioTab-module__container--piDZ2 .table-height-provider{padding:10px 24px 24px}.AudioTab-module__container--piDZ2 .empty-tab-message{padding-top:161px}.AudioTab-module__container--piDZ2 .AudioTab-module__compare--sVbqv .table-height-provider{padding:0}.AudioTab-module__container--piDZ2 .AudioTab-module__tableWrapper--xNRqC .ds-react-grid{border:1px solid var(--gray);border-radius:5px;overflow:hidden}.AudioTab-module__container--piDZ2 .AudioTab-module__tableWrapper--xNRqC .ds-react-grid tr td{font-size:14px}.AudioTab-module__container--piDZ2 .AudioTab-module__tableWrapper--xNRqC .ds-react-grid.virtualized{height:var(--table-maxheight)}.AudioTab-module__container--piDZ2 .AudioTab-module__tableWrapper--xNRqC .AudioTab-module__cellContent--Ztirb{display:inline-block;max-width:100%}.AudioTab-module__container--piDZ2 .AudioTab-module__tableWrapper--xNRqC .AudioTab-module__ellipsis--uvZ7w{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.AudioTab-module__container--piDZ2 .AudioTab-module__tableWrapper--xNRqC .AudioTab-module__audioCell--HEY3S{height:70px;padding:5px 0}.AudioTab-module__container--piDZ2 .AudioTab-module__tableWrapper--xNRqC .AudioTab-module__audioCell--HEY3S .audio-player{height:60px}.AudioTab-module__container--piDZ2 .AudioTab-module__tableWrapper--xNRqC .AudioTab-module__audioActionCell--rGVNW{display:flex;justify-content:flex-end;align-items:center}.AudioTab-module__audioActionCellDropdown--ICM6j{padding:5px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `AudioTab-module__dsAccented--lThZ9`,
	"dsDefaultWeight": `AudioTab-module__dsDefaultWeight--NzRCf`,
	"dsUnderline": `AudioTab-module__dsUnderline--Pjlh1`,
	"dsAccented2": `AudioTab-module__dsAccented2--nWSk5`,
	"dsBodyXL": `AudioTab-module__dsBodyXL--J1GSg`,
	"dsBodyLarge": `AudioTab-module__dsBodyLarge--HchH1`,
	"dsBody": `AudioTab-module__dsBody--GQv1w`,
	"dsBodySmall": `AudioTab-module__dsBodySmall--o66Gl`,
	"dsBodyXS": `AudioTab-module__dsBodyXS--iMiNt`,
	"dsActionLarge": `AudioTab-module__dsActionLarge--aMAma`,
	"dsAction": `AudioTab-module__dsAction--Y1jfV`,
	"dsActionSmall": `AudioTab-module__dsActionSmall--JgpNl`,
	"dsColumnHeadLine": `AudioTab-module__dsColumnHeadLine--F3i1C`,
	"dsLightXL": `AudioTab-module__dsLightXL--MEbdG`,
	"dsLightLarge": `AudioTab-module__dsLightLarge--cCkYE`,
	"dsLight": `AudioTab-module__dsLight--Uw7Jl`,
	"dsLightSmall": `AudioTab-module__dsLightSmall--F0QCi`,
	"dsLightXS": `AudioTab-module__dsLightXS--vh27B`,
	"container": `AudioTab-module__container--piDZ2`,
	"compare": `AudioTab-module__compare--sVbqv`,
	"tableWrapper": `AudioTab-module__tableWrapper--xNRqC`,
	"virtualized": `AudioTab-module__virtualized--YKnGu`,
	"cellContent": `AudioTab-module__cellContent--Ztirb`,
	"ellipsis": `AudioTab-module__ellipsis--uvZ7w`,
	"audioCell": `AudioTab-module__audioCell--HEY3S`,
	"audioActionCell": `AudioTab-module__audioActionCell--rGVNW`,
	"audioActionCellDropdown": `AudioTab-module__audioActionCellDropdown--ICM6j`
};
module.exports = ___CSS_LOADER_EXPORT___;
